export const DEFAULTS = "defaults";
export const OPERATIONS_MAINTENANCE = "operations-maintenance";

// routes that are STEPS in the tool, but are not specific to the Life Cycle Cost (LCC)
// or the CAP-X flow of the tool
const PRIMARY_ROUTES = {
  HOMEPAGE: "/",
  PROJECT_INFORMATION: "/project-info",
  TRAFFIC_VOLUMES: "/traffic-volumes",
  DESIGN_SELECTION: "/design-selection",
};

// secondary routes that are shared between the Cap-X and LCC flows
const SECONDARY_ROUTES = {
  TRAFFIC_VOLUMES_DEFAULTS: `${PRIMARY_ROUTES.TRAFFIC_VOLUMES}/${DEFAULTS}`,
};

// routes that are not part of the STEPS flow of the tool
const STATIC_ROUTES = {
  ABOUT: "/about",
  CONTACT: "/contact",
  DISCLAIMER: "/disclaimer",
};

// the primary Life Cycle Cost (LCC) routes
// the main steps for the LCC part of the tool
const PRIMARY_LCC_ROUTES = {
  GLOBAL_INPUT_DATA: "/global-input-data",
  DELAY: "/delay",
  COST_PARAMETERS: "/cost-parameters",
  GLOBAL_SAFETY_DATA: "/global-safety-data",
  SAFETY: "/safety",
  OUTPUTS: "/outputs",
};

// child routes to the primary Life Cycle Cost (LCC) routes
const SECONDARY_LCC_ROUTES = {
  COST_PARAMETERS_DEFAULTS: `${PRIMARY_LCC_ROUTES.COST_PARAMETERS}/${DEFAULTS}`,
  COST_PARAMETERS_OPERATIONS_MAINTENANCE_DEFAULTS: `${PRIMARY_LCC_ROUTES.COST_PARAMETERS}/${DEFAULTS}/${OPERATIONS_MAINTENANCE}`,
  SAFETY_DEFAULTS: `${PRIMARY_LCC_ROUTES.SAFETY}/${DEFAULTS}`,
};

const PRIMARY_CAP_X_ROUTES = {
  CAPACITY_ANALYSIS: "/capacity-analysis",
};

export const ROUTES = {
  ...PRIMARY_ROUTES,
  ...SECONDARY_ROUTES,
  ...STATIC_ROUTES,
  ...PRIMARY_LCC_ROUTES,
  ...SECONDARY_LCC_ROUTES,
  ...PRIMARY_CAP_X_ROUTES,
};

// only for use in tests
// these are all the routes that have steps in the tool associated with them
export const TEST_ONLY_ROUTES_WITH_STEPS = {
  ...PRIMARY_ROUTES,
  ...PRIMARY_LCC_ROUTES,
  ...SECONDARY_LCC_ROUTES,
  ...PRIMARY_CAP_X_ROUTES,
};
